import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



// 导入Element UI的CSS样式文件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import websocket from 'vue-native-websocket';

import '@/assets/css//scrollbar.less'
import '../src/assets/css/global.css'
import '@/assets/css/common.less'
import '@/assets/css/btn.less'

Vue.use(websocket, '', {
  connectManually: true, // 手动连接
  format: 'json', // json格式
  reconnection: true, // 是否自动重连
  reconnectionAttempts: 5, // 自动重连次数
  reconnectionDelay: 2000, // 重连间隔时间
});
Vue.config.productionTip = false

// 使用Element UI组件库
Vue.use(ElementUI)
// 注册全局
Vue.use(VueRouter)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
